import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { PopupMenu } from '@kerfjs/ui/popup-menu';
import { ToolbarControlGroup } from '@kerfjs/ui/toolbar-control-group';
import { type SafeHtml } from 'kerfjs';
import { FileSpreadsheet, FileText, Share } from 'lucide';

/** Share / export menu: Kerf's PopupMenu in a single nested-dropdown group
 * (HS2-JX8P5D). Items close natively; `share-export` reads `data-item-id`. */
export function ShareControl(): SafeHtml {
  return (
    <ToolbarControlGroup label="Share" appearance="borderless" single={true} nestedDropdown={true}>
      <PopupMenu
        label="Share or Export"
        icon={<LucideIcon icon={Share} name="" />}
        caret={false}
        placement="bottom-end"
        rootAttributes={{ 'data-share-menu': '' }}
        items={[
          {
            label: 'PDF',
            action: 'share-export',
            icon: <LucideIcon icon={FileText} name="" />,
            attributes: { 'data-item-id': 'pdf' },
          },
          {
            label: 'Excel (XLSX)',
            action: 'share-export',
            icon: <LucideIcon icon={FileSpreadsheet} name="" />,
            attributes: { 'data-item-id': 'xlsx' },
          },
        ]}
      />
    </ToolbarControlGroup>
  );
}
